export default __webpack_public_path__ + "media/images/raty/star-half-mono-9e9f78076d2b8d8d2610c024f109ac6b.png";